<div class="ziro-admin-page-content">
  <div data-automation="bulk-line-appearance-management" class="col-md-10 offset-md-1 ziro-report-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div
          [innerHTML]="
            (isReadOnly
              ? 'tkey;reports.bulk_line_appearance_management.report.description.read_only'
              : 'tkey;reports.bulk_line_appearance_management.report.description'
            ) | escapeHtml
          "
        ></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <div class="bulk-line-appearance-management typeahead-width pb-4">
      <label
        class="typeahead-search input-group input-group-lg border-rad-all-8 bg-white"
        [ngClass]="{
          'typeahead-search__pending': isSearching,
          'typeahead-margin': !isShowTable,
          'dropdown-menu__pending': isSearching,
        }"
      >
        <span
          class="{{ ziroIcons.SEARCH }} fa-lg typeahead-search__icon"
          [ngClass]="{ 'icon-warning': isSearching }"
        ></span>
        <ng-template #resultTemplate let-r="result" let-t="term">
          @if (r.ref.extension !== '') {
            <div
              class="flex-fill dropdown-item__content"
              [ngClass]="{
                'dropdown-item__content--disabled': r.numberOfAssociatedDevices === 1,
              }"
              data-automation="search-result-row"
              (mouseenter)="tooltip?.open()"
              (mouseleave)="tooltip?.close()"
            >
              <span
                class="search-result-font"
                [class.disabled]="r.numberOfAssociatedDevices === 1"
                (click)="handleResultClick($event, r.numberOfAssociatedDevices)"
              >
                <span class="extension-class">
                  <small class="muted d-block">
                    {{ 'tkey;reports.bulk_line_appearance_management.table_header.extension' | translate }}
                  </small>
                  <span data-automation="search-result-row-extension">
                    <strong>{{ r.ref.extension | telephoneNumberFilter }}</strong>
                  </span>
                </span>
                <span class="description-class">
                  @if (r.ref?.description !== '') {
                    <small class="muted d-block">
                      {{ 'tkey;reports.bulk_line_appearance_management.table_header.description' | translate }}
                    </small>
                  }
                  <span
                    [ngClass]="{ 'd-block text-truncate': r.ref?.description?.length > 27 }"
                    [ngbTooltip]="r.ref?.description"
                    [disableTooltip]="r.ref?.description?.length < 27"
                    [placement]="'top-left'"
                    container="body"
                    data-automation="search-result-row-description"
                  >
                    {{ r.ref?.description }}
                  </span>
                </span>
                <span class="associated-devices-class">
                  <small class="muted d-block">
                    {{
                      'tkey;reports.bulk_line_appearance_management.table_header.number_associated_devices' | translate
                    }}
                  </small>
                  <span
                    #tooltip="ngbTooltip"
                    triggers="hover"
                    [autoClose]="true"
                    [ngbTooltip]="
                      'tkey;menu.report.line_appearance_management_report.typeahead.disabled.tooltip' | translate
                    "
                    container="body"
                    [disableTooltip]="r.numberOfAssociatedDevices !== 1"
                    placement="bottom"
                    data-automation="search-result-row-number-of-associated-devices"
                  >
                    {{ r.numberOfAssociatedDevices }}
                  </span>
                </span>
                <span class="server-class">
                  <small class="muted d-block">
                    {{ 'tkey;reports.bulk_line_appearance_management.table_header.cucm' | translate }}
                  </small>
                  <span data-automation="search-result-row-cucm-server">
                    {{ getCucmServerDescriptionFromId(r.ref.serverId) }}
                  </span>
                </span>
              </span>
            </div>
          }
          <div class="ps-4">
            @if (isNoResultsFound) {
              <span class="search-result-font disabled" data-automation="search-no-result-row" style="color: black">
                {{ 'tkey;global.search.no_results.text' | translate }}
              </span>
            }
            @if (isSearching && r.ref?.extension === '') {
              <span class="search-result-font disabled" data-automation="search-loading-row" style="color: black">
                {{ 'tkey;menu.report.line_appearance_management_report.loading_text' | translate }}
              </span>
            }
          </div>
        </ng-template>
        <input
          #typeaheadInput
          placeholder="{{ 'tkey;reports.line_appearance.search.placeholder' | translate }}"
          (keyup.arrowDown)="scroll($event)"
          (keyup.arrowUp)="scroll($event)"
          data-automation="bulk-line-appearance-management-typeahead"
          class="typeahead-search__input form-control"
          [(ngModel)]="model"
          (selectItem)="onPreviewClick($event.item)"
          [focusFirst]="true"
          [resultTemplate]="resultTemplate"
          [inputFormatter]="formatter"
          [ngbTypeahead]="search"
          (focus)="onFocus($event)"
          (keydown)="filterTypeaheadInput($event)"
          [ngClass]="{
            'dropdown-menu__pending': isSearching,
            'typeahead-search__input__disabled': isLinePreviewed,
          }"
        />
        @if (isSearching) {
          <i class="{{ ziroIcons.LOADING }} icon-warning fa-lg"></i>
        }
        @if (searchText !== '' && !isSearching) {
          <span class="ng-clear-wrapper clear-hover" data-automation="clear-search-query">
            <span class="ng-clear" aria-hidden="true" (click)="clearInput(true)">x</span>
          </span>
        }
      </label>
    </div>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    <div [hidden]="!isShowTable">
      <div [hidden]="isLoading" class="card">
        <div
          class="card-header"
          [innerHtml]="
            'tkey;menu.report.line_appearance_management_report.common.settings'
              | escapeHtml: { extension: extension | telephoneNumberFilter }
          "
        ></div>
        <div class="card-body">
          <div class="row">
            <div class="col-3">
              <ziro-text [fieldId]="'label'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'externalCallerId'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'externalCallerIdNumber'" [inlineLabel]="false"></ziro-text>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <ziro-text [fieldId]="'ringIdle'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'ringActive'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'maxNumberOfCalls'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'busyTrigger'" [inlineLabel]="false"></ziro-text>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <ziro-text [fieldId]="'callRecordingOption'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'callRecordingProfile'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'callRecordingMediaSource'" [inlineLabel]="false"></ziro-text>
            </div>
            <div class="col-3">
              <ziro-text [fieldId]="'monitoringCssName'" [inlineLabel]="false"></ziro-text>
            </div>
          </div>
        </div>
      </div>
      <legend [hidden]="isLoading">
        <p
          [innerHtml]="
            'tkey;menu.report.line_appearance_management_report.legend'
              | escapeHtml: { extension: extension | telephoneNumberFilter }
          "
        ></p>
      </legend>
      @if (isShowTable && !isLoading) {
        <ziro-datatable
          [isCondensed]="true"
          [columns]="columns"
          [rowDataSource]="tableRows"
          [uniqueRowIdentifier]="'deviceId'"
          (rowSelected)="onSelectRow()"
          [showSelectColumn]="!isReadOnly"
          [stickyColumnCount]="1"
          [mainFilterPlaceholder]="
            ('tkey;reports.datatable.search_placeholder' | translate) +
            ('tkey;menu.report.line_appearance_management_report.table.filter.owner' | translate) +
            ', ' +
            ('tkey;menu.report.line_appearance_management_report.table.filter.device.name' | translate) +
            ', ' +
            ('tkey;menu.report.line_appearance_management_report.table.filter.line.setting' | translate) +
            '...'
          "
          [dataAutomation]="tableDataAutomation"
          [class]="'ziro-card'"
        >
          <ziro-datatable-switch-filter
            [label]="'tkey;menu.report.line_appearance_management_report.table.filter.misconfigured' | translate"
            [matchFn]="showOnlyMisconfiguredFilter"
            [dataAutomation]="'show-only-misconfigured-switch-filter'"
            [tableId]="tableDataAutomation"
          ></ziro-datatable-switch-filter>
        </ziro-datatable>
      }
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
